/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@fortawesome/fontawesome-free/css/all.css";
import { fa } from "vuetify/iconsets/fa";
import { aliases, mdi } from "vuetify/iconsets/mdi-svg";
import colors from "vuetify/util/colors";

// Composables
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  icons: {
    aliases,
    defaultSet: "fa",
    sets: {
      mdi,
      fa,
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          background: "#F7FAFB",
          surface: "#FFFFFF",
          cardBorder: "#C0C8CA",
          navRail: "#F1F4F5",
          primary: "#2d5854",
          secondary: colors.teal.lighten2,
          accent: colors.orange.lighten2,
          counterRegistry: "#107da6",
          anchor: "#35827b",
          tertiary: "#666666",
          defaultButton: "#f5f5f5",
          lighterIcons: "#757575",
          lighterGreyIcons: "#212121",
          error: "#ff5252",
          info: "#2196f3",
          tabs: "#5ab1ef",
        },
      },
    },
  },
  components,
  directives,
  defaults: {
    VDataTable: {
      sortAscIcon: "fas fa-sort-up",
      sortDescIcon: "fas fa-sort-down",
      density: "compact",
      itemsPerPageOptions: [10, 25, 50, 100, 200],
    },
    VDataTableServer: {
      sortAscIcon: "fas fa-sort-up",
      sortDescIcon: "fas fa-sort-down",
      density: "compact",
      itemsPerPageOptions: [10, 25, 50, 100, 200],
    },
    VCard: {
      elevation: 0,
      variant: "flat",
      border: "sm cardBorder opacity-100",
      // the radius is driven by the --celus-card-radius variable, see settings.scss
    },
    VAutocomplete: {
      color: "primary",
      variant: "underlined",
    },
    VSelect: {
      color: "primary",
      variant: "underlined",
    },
    VTextField: {
      variant: "underlined",
      color: "primary",
    },
    VTextarea: {
      variant: "outlined",
      color: "primary",
    },
  },
});
